<template>
  <div
    class="d-flex align-center py-3 px-4 rounded text-no-wrap"
    :class="variant?.bgClass"
  >
    <SoIcon
      v-if="variant?.icon"
      :icon="variant.icon"
      class="mr-2"
      data-testid="limit-info-icon"
    />
    <div>
      <span data-testid="limit-info-value">
        <SoSkeleton
          v-if="autoSyncedAccountCountQuery.isLoading"
          class="d-inline-block"
          data-testid="limit-info-skeleton"
          width="1.5em"
          height="1em"
        />
        <template v-else>
          {{ autoSyncedAccountCountQuery.data }}
        </template>
        / {{ AUTO_SYNCED_ACCOUNT_LIMIT }}
      </span>
      auto-synced accounts
    </div>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoSkeleton from "@/components/SoSkeleton.vue"
  import SoIcon from "@/components/SoIcon.vue"
  import { AUTO_SYNCED_ACCOUNT_LIMIT } from "@/constants/syncedAccounts"
  import { AccountSyncService } from "@/services/admin/AccountSyncService"
  import { IconName } from "@/types/Icon"

  const WARNING_THRESHOLD_PERCENTAGE = 85 // %
  const ERROR_THRESHOLD_PERCENTAGE = 100 // %

  export default defineComponent({
    components: {
      SoIcon,
      SoSkeleton,
    },
    data() {
      return {
        AUTO_SYNCED_ACCOUNT_LIMIT,
        autoSyncedAccountCountQuery:
          AccountSyncService.getAutoSyncedAccountsCount(),
      }
    },
    computed: {
      variant(): { bgClass: string; icon: IconName } | null {
        const count = this.autoSyncedAccountCountQuery.data
        const errorThreshold =
          AUTO_SYNCED_ACCOUNT_LIMIT * (ERROR_THRESHOLD_PERCENTAGE / 100)
        const warningThreshold =
          AUTO_SYNCED_ACCOUNT_LIMIT * (WARNING_THRESHOLD_PERCENTAGE / 100)

        if (count >= errorThreshold) {
          return {
            bgClass: "bg-danger",
            icon: "alert",
          }
        }
        if (count >= warningThreshold) {
          return {
            bgClass: "bg-warning",
            icon: "alert",
          }
        }
        return null
      },
    },
  })
</script>
